import { _ as __rest, a as __assign } from '../../tslib.es6-2259bcab.js';
import { c as classNames } from '../../index-444bb648.js';
import * as React from 'react';

var styles = {"divider":"Divider_divider_4a0c6301"};

var Divider = React.forwardRef(function CodeBlock(props, ref) {
    var className = props.className, otherProps = __rest(props, ["className"]);
    return (React.createElement("hr", __assign({ ref: ref, className: classNames(styles.divider, className) }, otherProps)));
});

export { Divider };
